var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapping-box-container"},[_c('div',{staticClass:"controls",attrs:{"id":"controls"}}),_c('div',{staticClass:"loadingContainer"},[_c('Loader',{attrs:{"isLoading":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }